import { lazySendAutomatedMessage, MessageDetails } from 'owa-automated-message';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import getUserDiagnosticMap from './getUserDiagnosticMap';
import {
    PeopleFeedbackState,
    PeopleFeedback,
} from 'owa-recipient-common/lib/store/schema/PeopleFeedbackState';

const newLineHtml = '<br />';
const tableOpenTag = '<table border="1">';
const tableCloseTag = '</table>';
const rowOpenTag = '<tr>';
const rowCloseTag = '</tr>';

export interface FeedbackContent {
    checkedItems: string[];
    textComment: string;
}

export default async function(
    feedbackContent: FeedbackContent,
    peopleFeedbackState: PeopleFeedbackState
) {
    let feedbackMessage: string = '<b>User Selected Items:</b>';
    feedbackMessage += newLineHtml;
    feedbackContent.checkedItems.forEach(item => {
        feedbackMessage += item;
        feedbackMessage += newLineHtml;
    });

    if (feedbackContent.textComment) {
        feedbackMessage += newLineHtml;
        feedbackMessage += '<b>User Comments:</b>';
        feedbackMessage += newLineHtml;
        feedbackMessage += feedbackContent.textComment;
        feedbackMessage += newLineHtml;
    }

    feedbackMessage += newLineHtml;
    feedbackMessage += '<b>User Data:</b>';
    feedbackMessage += tableOpenTag;

    if (peopleFeedbackState.live || peopleFeedbackState.cache || peopleFeedbackState.directory) {
        // Write headers
        feedbackMessage += rowOpenTag;
        const feedback = peopleFeedbackState.live
            ? peopleFeedbackState.live
            : peopleFeedbackState.cache;
        Object.keys(feedback).forEach(key => {
            feedbackMessage += `<th>${key}</th>`;
        });
        feedbackMessage += rowCloseTag;

        // Write data - the data is not guaranteed to be written in the order of request
        feedbackMessage += writeFeedbackData(peopleFeedbackState.cache);
        feedbackMessage += writeFeedbackData(peopleFeedbackState.live);
        feedbackMessage += writeFeedbackData(peopleFeedbackState.directory);
    }

    feedbackMessage += tableCloseTag;
    feedbackMessage += writeUserDiagnosticData();

    let messageDetails = {
        subject: 'OWA People Suggestion Feedback',
        message: feedbackMessage,
        to: ['SubstrateSearchFeedback@service.microsoft.com', 'peopledsats@microsoft.com'],
    } as MessageDetails;

    let timeFormat = getUserConfiguration().UserOptions.TimeFormat;
    let sendAutomatedMessage = await lazySendAutomatedMessage.import();
    await sendAutomatedMessage(messageDetails, timeFormat);
}

function writeFeedbackData(feedback: PeopleFeedback): string {
    let feedbackSnippet: string = '';

    if (feedback) {
        feedbackSnippet += rowOpenTag;
        Object.keys(feedback).forEach(key => {
            feedbackSnippet += `<td>${feedback[key]}</td>`;
        });

        feedbackSnippet += rowCloseTag;
    }

    return feedbackSnippet;
}

function writeUserDiagnosticData(): string {
    let userDiagnosticMap = getUserDiagnosticMap();
    let userDiagnosticSnippet: string = '';
    userDiagnosticSnippet += newLineHtml;
    userDiagnosticSnippet += '<b>User Diagnostic Data:</b>';
    userDiagnosticSnippet += tableOpenTag;
    userDiagnosticSnippet += rowOpenTag;
    Object.keys(userDiagnosticMap).forEach(key => {
        userDiagnosticSnippet += `<th>${key}</th>`;
    });
    userDiagnosticSnippet += rowCloseTag;
    userDiagnosticSnippet += rowOpenTag;
    Object.keys(userDiagnosticMap).forEach(key => {
        userDiagnosticSnippet += `<td>${userDiagnosticMap[key]}</td>`;
    });
    userDiagnosticSnippet += rowCloseTag;
    userDiagnosticSnippet += tableCloseTag;

    return userDiagnosticSnippet;
}
